import NotPublished from './notPublished';

export default NotPublished;
